import { observer } from 'mobx-react-lite'
import { useRpSocketContext } from 'providers/RpSocketProvider'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import routes from '../../core/routes'
import { useStore } from '../../stores'
import { LobbyGamesSection } from '../index'
import placeholder from './img/placeHolderRpLobby.png'
import {
  ItemGame,
  ItemGameCard,
  ItemGameCardImg,
  ItemGameCardLimits,
  ItemGameName,
} from '../ListGamesRoulette'
import { numberWithSpaces } from '../../utils/number'

const ListGamesRussianPoker: FC = observer(() => {
  const { russianPokerGamesStore } = useStore()
  const { isConnected, emit, on, off } = useRpSocketContext()
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isConnected) {
      russianPokerGamesStore.stopLobbyGamesFeed()
      return undefined
    }

    russianPokerGamesStore.startLobbyGamesFeed({ emit, on, off })

    return () => {
      russianPokerGamesStore.stopLobbyGamesFeed()
    }
  }, [isConnected, emit, on, off, russianPokerGamesStore])

  return (
    <LobbyGamesSection title={`${t('russianPoker')}`}>
      {russianPokerGamesStore.games.map((item) => {
        const min = numberWithSpaces(item.limit.min)
        const max =
          item.limit.max === null ? 'unlim' : numberWithSpaces(item.limit.max)

        return (
          <ItemGame
            key={item.id}
            data-cy={`russian-poker-lobby-game-${item.name}`}
            onClick={() => {
              navigate(`${routes.russianPoker}/${item.id}`)
            }}>
            <ItemGameCard>
              <ItemGameCardImg src={placeholder} alt={item.name} />
              <ItemGameCardLimits>
                {min} - {max}
              </ItemGameCardLimits>
            </ItemGameCard>
            <ItemGameName>{item.name}</ItemGameName>
          </ItemGame>
        )
      })}
    </LobbyGamesSection>
  )
})

export default ListGamesRussianPoker
